function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M61 24L37.083 56 20 42.526"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 40.5a39.5 39.5 0 1079.001 0A39.5 39.5 0 001 40.5h0z"
}));

function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81
  }, props), _ref);
}

export default SvgSuccess;